export enum LocalScenario {
    PiggyGame = 'piggygame',
}
